import React from "react";
import { ReactComponent as SearchIcon } from "../icons/search.svg";
import { ISearch } from "../../@types/types";

interface SearchInputProps {
  search: ISearch;
  inputValue: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  hasMargin?: boolean;
}

const SearchInput: React.FC<SearchInputProps> = ({
  search,
  inputValue,
  onChange,
  hasMargin,
}) => {
  const onSearch = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const url = search.targetUrl.split("{SEARCH_VALUE}");
    if (url.length) {
      window.location.href = `${url[0]}${inputValue}`;
    }
  };

  return (
    // <form onSubmit={onSearch}>
    //   <label>
    //     <input
    //       type='text'
    //       placeholder={search.placeholder}
    //       value={inputValue}
    //       onChange={onChange}
    //     />
    //     <SearchIcon />
    //   </label>
    // </form>
    <form
      className='input-form'
      style={
        hasMargin
          ? {
              marginTop: "10px",
              marginLeft: "0px",
              marginRight: "12px",
              marginBottom: "15px",
            }
          : {}
      }
      onSubmit={onSearch}
    >
      <input
        className='input'
        type='text'
        placeholder={search.placeholder}
        value={inputValue}
        onChange={onChange}
      />
      <SearchIcon />
    </form>
  );
};

export default SearchInput;
